import React, { useState, useEffect } from 'react';
import Table from 'view/component/Table';
import Card from 'view/component/Card';
import DatePicker from 'react-datepicker';
import { Modal } from 'react-bootstrap';
import moment from 'moment';
import apiService from 'apiService';
import { InlineLoading } from 'view/component/Loading';

const toBase64 = async (file) => {
  if (await file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }
};

const UploadFile = ({ data, idPendaftaran }) => {
  const [ isLoading, setIsLoading ] = useState(false);
  const [ isCompleted, setIsCompleted ] = useState(false);
  const [ error, setError ] = useState('');

  function validate(file, maxSize, extension) {
    let thisError;
    const extensions = extension.split(',').map((validate) => validate);
    const arrFileName = file.name.split('.');
    const fileExtension = arrFileName[ arrFileName.length - 1 ].toLowerCase();

    if (!extensions.includes(fileExtension)) {
      thisError = `extensi file harus ${ extension }`;
      setError(thisError);
      return false;
    } else if (file.size > maxSize) {
      thisError = `ukuran file melebihi ${ maxSize / 1000000 } MB`;
      setError(thisError);
      return false;
    } else {
      setError('');
      return true;
    }
  }

  const handleChange = async (e, data) => {
    if (!validate(e.target.files[ 0 ], data.max_size, data.extension)) return '';
    setIsLoading(true);
    const fileBase64 = await toBase64(e.target.files[ 0 ]);
    const post = {
      id: data.id,
      ref_persyaratan_id: data.ref_persyaratan_id,
      trx_pend_perusahaan_id: idPendaftaran,
      keterangan: data.keterangan,
      verified: data.verified,
      upload: fileBase64,
    };
    const result = await apiService.put('/department/persyaratan/update', post);
    if (result) {
      setIsLoading(false);
      setIsCompleted(true);
    }
  };

  return (
    <>
      <label>
        <span>upload perbaikan</span>
        <span className='text-success pl-2'>
          {isCompleted && <i className='fas fa-check-circle fa-1x' />}
        </span>
      </label>
      <br />
      <input type='file' onChange={ (e) => handleChange(e, data) } />
      <br />
      {isLoading ? (
        <InlineLoading isLoading={ isLoading } />
      ) : error ? (
        <span className='text-danger'>{error}</span>
      ) : (
        ''
      )}
    </>
  );
};

const View = ({
  data,
  handleSubmit,
  setTanggalKunjungan = '',
  idPendaftaran,
}) => {
  const openFile = (url) => {
    const win = window.open(url, '_blank');
    if (!win) {
      win.focus();
    }
  };

  return (
    <>
      <h2 className='mb-2'> Status Verifikasi Persyaratan</h2>
      <Table
        pagination={ false }
        headers={ [ 'No', 'Nama', 'File', 'Status', 'Keterangan', '' ] }
        data={ data }
        columnMapper={ (value, i) => {
          return [
            <span
              style={ {
                whiteSpace: 'initial',
                overflow: 'hidden',
              } }>
              {value.name || value.detail.name}
            </span>,
            value.upload ? (
              <span
                onClick={ () => openFile(value.upload) }
                className='text-primary'
                style={ { cursor: 'pointer' } }>
                Lihat file persyaratan
              </span>
            ) : (
              'Tidak ada file'
            ),
            value.verified === 'yes' ? (
              <span className='text-success'>Terverifikasi</span>
            ) : value.verified === 'no' && value.keterangan ? (
              <span className='text-danger'>Perlu Diperbaiki</span>
            ) : (
              <span>Proses Verifikasi</span>
            ),
            <span
              style={ {
                whiteSpace: 'initial',
                overflow: 'hidden',
              } }>
              {value.keterangan}
            </span>,
            value.verified === 'no' && value.keterangan && (
              <>
                <UploadFile data={ value } idPendaftaran={ idPendaftaran } />
              </>
            ),
          ];
        } }
      />
    </>
  );
};

export default View;
